module.exports = __webpack_public_path__ + "img/cover.7f75a15e.webp";